import { useFilterForm } from './useFilterForm';
import { isEmpty } from 'lodash';
import { z } from 'zod';

export const orderingSchema = z.object({
  ordering: z.string().optional(),
});

export function useSortableTable(defaultSort: string) {
  const { values, setValue } = useFilterForm(orderingSchema.parse);
  const ordering = values.ordering ?? defaultSort;

  function register(key: string) {
    return {
      sort: ordering === key ? 'desc' : ordering === `-${key}` ? 'asc' : (undefined as 'asc' | 'desc' | undefined),
      onClick: () => setValue('ordering', ordering === key ? `-${key}` : key),
    };
  }

  return {
    values: isEmpty(values) ? { ordering: defaultSort } : values,
    register,
  };
}
